import type { JSX } from 'react';
import React, { useMemo } from 'react';

import type { WithSlotProps } from '~/components/hocs';
import type { DefineSlots } from '~/components/layout/utils';
import { withSlot } from '~/components/hocs';
import { componentRegistry, componentSlots, renderChild } from '~/components/layout/utils';
import { SlotsProvider } from '~/components/providers';
import { useConfig, useTemplate } from '~/hooks';
import { cn } from '~/utils/cn';

export const NAME = 'CommentsLoadMore';

export const Slots = componentSlots(NAME, {
  LOAD_MORE: 'loadMore',
  LOAD_MORE_BTN: 'loadMoreBtn',
  PATH_CONNECTOR: 'pathConnector',
});

type SlotProps = DefineSlots<
  typeof Slots,
  {
    [Slots.LOAD_MORE]: JSX.IntrinsicElements['div'];
    [Slots.LOAD_MORE_BTN]: JSX.IntrinsicElements['button'];
    [Slots.PATH_CONNECTOR]: JSX.IntrinsicElements['div'];
  }
>;

export interface Props extends React.PropsWithChildren, WithSlotProps {
  className?: string;
  amount: number;
  templateStr?: string;
  disabled?: boolean;
  isLast: boolean;
  onLoadMoreClick: () => void;
}

// TODO: refactor getting default props to a sepparate HOC probably
const CommentsLoadMoreComponent = (props: Props) => {
  const defaultProps = useConfig().defaultProps?.[NAME] ?? {};
  const template = useTemplate(NAME);
  const { amount, templateStr, disabled, isLast, onLoadMoreClick } = { ...defaultProps, ...props };

  const slots = useMemo<SlotProps>(
    () => ({
      [Slots.PATH_CONNECTOR]: {
        className: cn(isLast && 'last'),
      },
      [Slots.LOAD_MORE]: {
        className: cn(disabled && 'disabled'),
        onClick: () => {
          onLoadMoreClick();
        },
      },
      [Slots.LOAD_MORE_BTN]: {
        children: templateStr?.replace('{{amount}}', amount.toString()) ?? 'טען עוד',
      },
    }),
    [templateStr, amount, disabled, isLast, onLoadMoreClick]
  );

  return <SlotsProvider slots={slots}> {renderChild(template)}</SlotsProvider>;
};

CommentsLoadMoreComponent.displayName = NAME;

export const CommentsLoadMore = withSlot(CommentsLoadMoreComponent);
componentRegistry.add(NAME, CommentsLoadMore as React.FC);
